import classNames from 'classnames';
import React from 'react';
import {toPersianQuality} from 'utilities/helper/toPersianQuality';

interface CardInfoProps {
  icon: string;
  title: string;
  grade: string | null;
}
const CardInfo = ({grade, title, icon}: CardInfoProps) => {
  return (
    <div className="flex gap-2 justify-between ">
      <div className="flex justify-start gap-2">
        <span className={classNames('', icon)} />
        <span className="text-black font-extrabold text-sm  overflow-hidden max-w-[212px] max-h-[40px] overflow-ellipsis  grow text-start">
          {title}
        </span>
      </div>
      {grade && (
        <div className="text-xs bg-orange-4 text-primary h-fit flex text-center items-center py-1 align-middle px-2 rounded-2xl">
          درجه {toPersianQuality[grade].degree}
        </div>
      )}
    </div>
  );
};

export default CardInfo;
